import Api from '@/api/index';

const Prospect = {
  namespaced: true,
  state: {
    value: 'my value',

    oneProspect: null, //to store SHOW response
    allProspects: null, //to store SHOW response

    //promises results
    createProspectWasGood: null,
    createProspectMessage: null,
    
    updateProspectWasGood: null,
    updateProspectMessage: null,

     // less used
    indexProspectWasGood: null,
    indexProspectMessage: null,

    showProspectWasGood: null,
    showProspectMessage: null,
  },
  getters: {
    getStateValue: state => {
      return state.value;
    }
  },

  mutations: {
    setOneProspect(state, Prospect){
      state.oneProspect = Prospect // Prospect.data
    },
    setAllProspects(state, Prospects){
      state.allProspects = Prospects // Prospects.data
    },

    createResponse(state, {was_good, msg}){
      state.createProspectWasGood = was_good
      state.createProspectMessage = msg
      setTimeout(() => {
        state.createProspectrWasGood = null
      }, 100);
    },
    updateResponse(state, {was_good, msg}){
      state.updateProspectWasGood = was_good
      state.updateProspectMessage = msg
      setTimeout(() => {
        state.updateProspectrWasGood = null
      }, 100);
    },
    indexResponse(state, {was_good, msg}){
      state.indexProspectWasGood = was_good
      state.indexProspectMessage = msg
      setTimeout(() => {
        state.indexProspectrWasGood = null
      }, 100);
    },
    showResponse(state, {was_good, msg}){
      state.showProspectWasGood = was_good
      state.showProspectMessage = msg
      setTimeout(() => {
        state.showProspectrWasGood = null
      }, 100);
    },

    updateOneProspect(state, prospect){
      state.oneProspect = {
        ...state.oneProspect,
        ...prospect,
      }
    },

    clearAllProspects(state){
      state.allProspects = null
    },
    clearOneProspect(state){
      state.oneProspect = null
    },
  },

  actions: {
    clearAllProspects({commit}){
      commit('clearAllProspects')
    },
    clearOneProspect({commit}){
      commit('clearOneProspect')
    },

    index(context, filter) {
      Api.Prospect.index(filter)
        .then(response => response.data)
        .then(Prospects => {
          context.commit('setAllProspects', Prospects);
          context.commit('indexResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('indexResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    show(context, Prospect_id) {
      return Api.Prospect.show(Prospect_id)
        .then(response => response.data)
        .then(Prospect => {
          Prospect = Prospect.data? Prospect.data.attributes : Prospect
          context.commit('setOneProspect', Prospect);
          context.commit('showResponse', {msg: '', was_good: true});
          return Prospect
        }).catch(function(error) {
          context.commit('showResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    create(context, new_Prospect) {
      return Api.Prospect.create(new_Prospect)
        .then(response => response.data)
        .then(Prospect => {
          Prospect = Prospect.data? Prospect.data.attributes : Prospect
          // context.commit('setOneProspects', Prospect); // not often used
          context.commit('createResponse', {msg: '', was_good: true});
          return Prospect
        }).catch(function(error) {
          context.commit('createResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    update(context, Prospect) {
      return Api.Prospect.update(Prospect)
        .then(response => response.data)
        .then(Prospect => {
          Prospect = Prospect.data? Prospect.data.attributes : Prospect
          context.commit('updateOneProspect', Prospect); // not often used
          context.commit('updateResponse', {msg: '', was_good: true});
          return Prospect
        }).catch(function(error) {
          context.commit('updateResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },

    updateOneProspect(context, Prospect) {
      context.commit('updateOneProspect', Prospect); // not often used
    }
  }

};

export default Prospect;